import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { HeaderComponent, SpinnerComponent, SelectDropdownModule } from '@core/components';
import { LayoutComponent } from "@core/layouts";
import { MaterialModule } from "@core/material";
import { SidebarMenuComponent } from './components/sidebar-menu/sidebar-menu.component';
import { IsTruncatedPipe } from "./pipes";
import { CustomPaginatorDirective } from "./components/directives/custom-paginator.directive";
import { TranslateModule } from "@ngx-translate/core";

const COMPONENTS = [
    HeaderComponent,
    SpinnerComponent,
    LayoutComponent,
    SidebarMenuComponent
];

const PIPES = [
    IsTruncatedPipe,
];

const DIRECTIVES = [
    CustomPaginatorDirective,
];

@NgModule({
    imports: [CommonModule, MaterialModule, SelectDropdownModule, TranslateModule],
    exports: [CommonModule, ...COMPONENTS, MaterialModule, SelectDropdownModule, ...PIPES, ...DIRECTIVES, TranslateModule],
    declarations: [...COMPONENTS, ...PIPES, ...DIRECTIVES,]
})

export class CoreModule { }